const EventActions = {

    //  Browser unloading event
    BrowserUnload: 'browser_unload',

    //  Location changed
    LocationChanged: 'location_changed',

    //  User profile updated
    UserInfoUpdated: 'user_info_updated',

    //  Tractor request update
    TractorRequestUpdate: 'on_request_update',

    //  User logout event
    UserLogout: 'user_logout',

    //  User profile image updated event
    UserProfileImageUpdated: 'user_profile_updated',

    //  User notifications update
    NotificationUpdate: 'update_notifications_hint',

    //  Show change phone number event
    ShowChangePhone: 'show_change_phone',

    //  Show change email event
    ShowChangeEmail: 'show_change_email',

    //  Payment updated
    PaymentsUpdate: 'on_payment_update',

    //  Refresh active page
    RefreshActivePage: 'on_refresh_active_page',

    //  Show tractor request handler
    ActiveTractorRequestHandler: "handle_tractor_request",

    //  Refresh operator requests
    OperatorRequestUpdate: 'on_operator_request_update'
};

export default EventActions;


// WEBPACK FOOTER //
// ./src/common/Events/Actions.js